export function entityDecode (string) {
    return string.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
    });
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/entity-decode.ts